import { Button } from "antd";
import React from "react";

const PiRequestStatus = (props) => {
  const sendTrackId = (trackId, id,value) => {
    props.getTrackNumberAndId([trackId, id]);
    props.getRejectValue(value);
    props.close();
  };

  const rejectRequest = (trackId, id, value) => {
    props.getTrackNumberAndId([trackId, id]);
    props.getRejectValue(value);
    props.close();
  };

  return (
    <div
      style={{
        display: "flex",
         gap: "70px",
       }}
    >
      <div
        className="card-data-spacing text-center"
        style={{
          // width: "35%",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          Comments
        </span>
        <span>{props?.data?.comments}</span>
      </div>
      <div
        className="card-data-spacing text-center"
        style={{
          // width: "35%",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          Tracking Number
        </span>
        <span>{props?.data?.trackingNumber}</span>
      </div>
      {props?.data?.requestOpen && (
        <div
          className="text-center"
          style={{
            // width: "35%",
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            Status
          </span>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <Button
              onClick={() =>
                sendTrackId(props?.data?.trackingNumber, props?.data?.orderId,'approved')
              }
              className="success_button"
            >
              Accept
            </Button>
            <Button
              onClick={() =>
                rejectRequest(
                  props?.data?.trackingNumber,
                  props?.data?.orderId,
                  "rejectApprove"
                )
              }
              className="reject_button"
            >
              Reject
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PiRequestStatus;
